<template>
  <div>
    <div class="_prev"  v-if="dialogImgArr.length > 1">
      <el-image
        @click.stop="arrowClick('prev')"
        style="width: 80px; height: 80px;cursor: pointer;"
        :src="require('../assets/img/textform/cprev.png')" fit="contain">
        <div slot="placeholder" class="image-slot"></div>
      </el-image>
    </div>
    <div class="_next"  style="right: 0;" v-if="dialogImgArr.length > 1">
      <el-image
        @click.stop="arrowClick('next')"
        style="width: 80px; height: 80px;cursor: pointer;"
        :src="require('../assets/img/textform/cnext.png')" fit="contain">
        <div slot="placeholder" class="image-slot"></div>
      </el-image>
    </div>

    <div class="_close" >
      <el-image
        @click.stop="handleClose"
        style="width: 30px; height: 30px;cursor: pointer;"
        :src="require('../assets/img/textform/close.png')" fit="contain">
        <div slot="placeholder" class="image-slot"></div>
      </el-image>
    </div>


    <el-dialog
      class="carousel_dialog dialog"
      :visible.sync="dialogCarouselVisible"
      :before-close="handleClose"
      :show-close="false"
      append-to-body
      custom-class="out_dialog"
      :width="dialogSize + 'px'"
    > 
      <div class="cont" :style="{  width: dialogSize + 'px'  , height: dialogSize + 'px'}">
        <el-carousel  :height="dialogSize + 'px'"  arrow="never" :autoplay="false" :initial-index="imgIdx" indicator-position="none" ref="cardShow">
          <el-carousel-item v-for="(item , idx ) in dialogImgArr" :key="idx">
            <el-image :src="item.image" class="avatar" fit="contain" style="margin-left: 5px;"   :style="{  width: dialogSize + 'px'  , height: dialogSize + 'px'}">
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>

  </div>

</template>
<script>
import {  consumeRecordReq  ,  rechargeRecordReq  } from "@/api/record"

export default {
  props : {
    dialogCarouselVisible: {
      type: Boolean ,
      default: false , 
    },
    dialogImgArr: {
      type: Array ,
      default: [] , 
    },
    imgIdx : {
      type: Number , 
      default : 0 , 
    }
  }, 
  data(){
    return {
      chongzhitype : "0" ,
      pageNum : 1, 
      pageSize : 10 , 
      total : 0 , 
      data1 : [] , 
      data2 : [] ,

      dialogSize : 600 , 
    }
  },    
  methods: {
    handleClose(done) {
      this.$emit('update:dialogCarouselVisible',  false ) // 传递更新数值
      this.$emit('update:dialogImgArr',  [] ) // 传递更新数值

    } ,
    chongzhiToggle( type ){
      this.chongzhitype = type ;
    } ,
    getConsumeRecord(){
      consumeRecordReq({
        pageNum : this.pageNum , 
        pageSize : this.pageSize , 
      }).then( res => {
        this.total = res.data.total ;
        this.data1 = res.data.records ;
      })
    } ,
    getRechargeRecord(){
      rechargeRecordReq({
        pageNum : this.pageNum , 
        pageSize : this.pageSize , 
        type : this.chongzhitype , 
      }).then( res => {
        this.total = res.data.total ;
        this.data2 = res.data.records ;
      })
    },

    paginationList(){
      if(  this.dialogRecordType == "1"  ){
        this.getConsumeRecord()
      } else if( this.dialogRecordType == "2" ){
        this.getRechargeRecord()
      }
    },
    reset(){
      this.pageNum = 1 ;
      this.pageSize = 10 ; 
      this.total = 0 ; 
      this.data1 = [] ;
      this.data2 = [] ;
    },
    arrowClick(val){
      if(val === 'next') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    }
  } ,
  mounted(){
    if(  this.dialogRecordType == "1"  ){
      this.getConsumeRecord()
    } else if( this.dialogRecordType == "2" ){
      this.getRechargeRecord()
    }

    if( window.screen.availHeight > window.screen.availWidth ){
      this.dialogSize = window.screen.availWidth - 150 ;
    } else {
      this.dialogSize = window.screen.availHeight - 150 ;
    }
  },
  watch: {
    // 记录类型切换了
    dialogRecordType: function (newQuestion, oldQuestion) {
      this.reset();
      this.chongzhitype = "0";
      if(  this.dialogRecordType == "1"  ){
        this.getConsumeRecord()
      } else if( this.dialogRecordType == "2" ){
        this.getRechargeRecord()
      }
    },
    chongzhitype: function (newQuestion, oldQuestion) {
      this.reset();
      if(  this.dialogRecordType == "1"  ){
        this.getConsumeRecord()
      } else if( this.dialogRecordType == "2" ){
        this.getRechargeRecord()
      }
    },
  },
}
</script>

<style lang="scss" scoped>  
::v-deep ._prev {
  position: absolute;
  left: 0;
  top: 45%;
  z-index: 10000;
}
::v-deep ._next {
  position: absolute;
  right: 0;
  top: 45%;
  z-index: 10000;
}
::v-deep ._close {
  position: absolute;
  right: 25px;
  top: 28px;
  z-index: 10000;
}


::v-deep .dialog {
  position: relative;

}

::v-deep .el-dialog {
min-width: 200px;
// position: relative;
// background-color: palegreen;
// background-color:#1B1D2E  !important;
// background-color: rgba(40,40,40,0.4) !important;
background-color: rgba(0,0,0,0) !important;
box-shadow : none ;

display: flex;
margin: 0 !important;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
/*height:600px;*/
max-height: calc(100% - 30px);
max-width: calc(100% - 30px);
border-radius: 20px ;

.el-dialog__header {
  display: none;
}
.el-dialog__body {
  padding: 0;    
  .cont {
      min-width: 200px;
      min-height: 200px;
  }
}


}


/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
 background-color: transparent !important;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
 background-color: transparent !important;
 border: 0; //去除表格
}
/*去除底边框*/
::v-deep.el-table td.el-table__cell {
 border: 0;
}
::v-deep.el-table th.el-table__cell.is-leaf {
 border: 0;
}
/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
  display: none;
}

::v-deep .el-table__header-wrapper .cell {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #999999;
}
::v-deep .el-table__body-wrapper .cell{
  color: #fff;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;}


/*设置xx条/页的框的颜色*/
::v-deep .el-select .el-input.is-focus .el-input__inner,
::v-deep .el-pagination__sizes .el-input .el-input__inner:hover,
::v-deep .el-select .el-input__inner:focus {
    border-color: #006FFF;
}
/*设置当前页码的样式，及鼠标移上其他页码时的样式,以及左右箭头鼠标移上的样式*/

::v-deep .el-pagination {
  background-color: transparent;
}
::v-deep .el-pager li.active,.el-pager li:hover,
::v-deep .el-pagination button:hover {
    color: #006FFF;
}

::v-deep .el-pagination{
  color: #fff;
}
::v-deep .el-pagination .el-pager li{
  background: transparent;
}
::v-deep .el-pagination button:disabled  , ::v-deep .el-pagination button {
  background: transparent;
}
::v-deep .el-pagination button  {
  color: #fff;
}
::v-deep .el-table--mini .el-table__cell {
  padding: 8px 0 ;
}



</style>